import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
export default function FAQ() {
	useDocumentTitle("FAQ");
	return (
		<div className="p-4">
			<h1 className="text-lg mb-6">FAQ</h1>
			<div className="space-y-4">
				<div className="h-12 rounded-lg bg-muted animate-pulse" />
				<div className="h-12 rounded-lg bg-muted animate-pulse" />
				<div className="h-12 rounded-lg bg-muted animate-pulse" />
				<div className="h-12 rounded-lg bg-muted animate-pulse" />
			</div>
		</div>
	);
}
